module.exports = __webpack_public_path__ + "img/subtlety.7dbab5fd.jpg";